import { render, staticRenderFns } from "./BucketDetails.vue?vue&type=template&id=e4c02926&"
import script from "./BucketDetails.vue?vue&type=script&lang=ts&"
export * from "./BucketDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports